module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/operations.c87f648f.svg";